<template>
  <b-table
    :class="['gk-table gk-table--responsive gk-table--striped gk-table--hover']"
    :items="existingDocumentList"
    :fields="documentTableFields"
    :busy="loading"
    show-empty
    table-busy
  >
    <template #empty="">
      {{ $gettext('No documents found.') }}
    </template>
    <template #cell(actions)="data">
      <GekkoButton 
        @click="downloadDocument(data.item)"
        icon="fa-solid fa-download"
        variant="link" 
        class="text-info"
      />
      <GekkoButton
        v-if="useStore && deletable"
        icon="fa-solid fa-trash-can"
        variant="link" 
        class="text-danger"
        v-gk-confirm="{
          title: $gettext('Delete file?'),
          message: $gettext('Are you sure you want to delete this document? This can\'t be undone.'),
          options: {
            variant: 'danger',
            confirmText: $gettext('Delete')
          },
          callback: deleteDocument,
          callbackParams: data.item.id,
        }"
      />
    </template>
  </b-table>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import DocumentService from "@/store/services/document.service";
import GekkoButton from "@/components/GekkoButton"

export default {
  name: "CorrectionDocumentList",
  components: {
    GekkoButton
  },
  props: {
    objectId: {
      type: Number,
      default: null
    },
    useStore: {
      type: Boolean,
      default: false
    },
    deletable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      documentTableFields: [
        { key: 'title', label: '' },
        { key: 'actions', label: '', tdClass: 'text-right' }
      ],
      loading: true,
      existingDocumentList: []
    }
  },
  computed: {
    ...mapGetters({ 
      correctionFiles: 'invoices/getCorrectionFiles',
    }),
  },
  created () {
    this.getDocuments()
  },
  methods: {
    ...mapActions({ 
      deleteDocument: 'invoices/deleteDocument',
    }),
    getDocuments () {
      if (this.useStore) {
        this.existingDocumentList = this.correctionFiles
        this.loading = false
      } else {
        DocumentService.getContentType({ type: 'Correction' }).then((response) => {
          DocumentService.list({ content_type: response.data, object_id: this.objectId }).then((response) => {
            this.existingDocumentList = response.data.results
            this.loading = false
          })
        })
      }
    },
    downloadDocument (file) {
      location.href = window.Urls['documents:download'](file.id)
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
